'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable import/prefer-default-export */

/**
 * Binds onClick to space and reurn key
 * @param {*} handler
 */
var Select = exports.Select = function Select(handler) {
  return function (event) {
    if (event.type === 'click' || event.keyCode === 32 ||
    // Space
    event.keyCode === 13 // Return
    ) {
      event.preventDefault();
      return handler(event);
    }
    return function () {};
  };
};